import type { RulePhase } from '../content/types';
import type { GameContext } from '../core/GameContext';

export class RuleSystem {
  run(context: GameContext, phase: RulePhase): void {
    for (const rule of context.level.rules[phase]) rule.execute(context, rule.params);
  }
}
